import { render, staticRenderFns } from "./user-task-badge-component.vue?vue&type=template&id=0834333f&scoped=true"
import script from "./user-task-badge-component.ts?vue&type=script&lang=ts&external"
export * from "./user-task-badge-component.ts?vue&type=script&lang=ts&external"
import style0 from "./user-task-badge-component.scss?vue&type=style&index=0&id=0834333f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0834333f",
  null
  
)

export default component.exports